/* eslint-disable default-param-last */

const initialState = {
  hasError: false,
  user: {
    title: '',
    message: '',
  },
  developer: {
    detail: '',
    source: '',
  },
};

export default function error(state = initialState, action) {
  switch (action.type) {
    case 'SHOW_ERROR':
      return {
        ...state,
        hasError: true,
        ...action.payload,
      };
    case 'DISMISS_ERROR':
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}
